import { fuego } from '@store/firebase';
import { CollectionPath } from '@typings/collections.enum';

export async function countCollection(collectionPath: string): Promise<number> {
  const counterRef = fuego.db.collection(CollectionPath.COUNTERS);

  const collectionCount = await counterRef
    .doc(collectionPath)
    .get()
    .then((snap) => snap.get('count'));
  return collectionCount;
}

export async function getAllDocsLength(
  collectionPath: string,
): Promise<number> {
  const colRef = fuego.db.collection(collectionPath);
  return colRef.get().then((res) => res.docs.length);
}
